export const mediaAudioStateSelector = state => state.stickers.mediaAudio;